/**
 * interface generic Log and log use in application
 * @packageDocumentation
 * @module LogService
 */

import { injector } from "../dependencies/injector";

export const LOG_SERVICE = "LogService";
/**
 * LogService interface 
 */
export interface LogService {
    debug(...msg: unknown[]): void;
    info(...msg: unknown[]): void;
    warn(...msg: unknown[]): void;
    error(...msg: unknown[]): void;
}

/**
 * Access Log service instance
 */
export function getLogService(): LogService {
    return injector.get<LogService>(LOG_SERVICE);
}

/**
 * Access Log service instance if registered
 */
export function findLogService(): LogService | undefined {
    return injector.find<LogService>(LOG_SERVICE);
}

/**
 * Access Log service instance if registered and returns standard console otherwise
 */
export function getLogConsole(): LogService {
    return injector.find<LogService>(LOG_SERVICE) ?? console;
}